<template>
  <v-container class="fill-height">
    <v-row align="center"
           justify="center">
      <v-col cols="12"
             sm="8"
             md="6">
        <div class="d-flex flex-column justify-center align-center">
          <v-progress-circular :size="160"
                               :width="10"
                               indeterminate
                               color="primary"
                               class="mb-4">
          </v-progress-circular>
          <h2>
            Opening Presentation
          </h2>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import contentService from '../../services/contentService';
import presentationService from '../../../../ml/services/presentationService';

export default {
  computed: {
    presentationID() {
      return parseInt(this.$route.params.presentationID);
    }
  },
  created() {
    this.open(this.presentationID);
  },
  methods: {
    async open(presentationID) {
      try {
        const presentation = await presentationService.getPresentation(presentationID);
        const newTab = false;
        const data = {
          live_mode: true,
          payload: {
            is_powerpoint: false,
            use_onlyoffice: false,
          }
        }
        await contentService.launchPresentation(presentation, newTab, this.$router, data);
        this.$store.dispatch('closeDrawer').then(); // MLD-5641
      } catch (error) {
        this.$toast.error('You do not have access to that presentation.');
        await this.$router.replace({name: `${this.$root.routePrefix}.home`});
      }
    }
  }
}
</script>
